<template>
<div ui-view="" class="app-body" id="view">
  <component v-bind:is="component" board-title="개인정보처리방침관리" board-name="privacyPolicy"></component>
</div>
</template>

<script>
import BoardDetail from './BoardDetail.vue'
import BoardEdit from './BoardEdit.vue'
import BoardList from './BoardList.vue'

export default {
  components: { BoardList, BoardEdit, BoardDetail },
  data() {
    return {
      component: null
    }
  },
  mounted(){
    this.init();
  },
  watch:{
    $route(to) { 
      this.init();
    }
  },
  methods: {
    init(){
     if(this.$route.query.mode== 'view'){
        this.component = BoardDetail
        return;
      }
      if(this.$route.query.mode== 'new' || this.$route.query.mode == 'edit'){
        this.component = BoardEdit
        return;
      }
      if(typeof this.$route.query.mode == "undefined" || this.$route.query.mode == 'list' || this.$route.query.mode == ''){
        this.component = BoardList
        return;
      }      
    }
  },
}
</script>

<style>

</style>